import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const IDIndex = lazy(() => import('./:id/Index'))

export const SignupRequestRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--entities--person']}>
    <Route index element={<Index />} />
    <Route path=':id/*' element={<IDIndex />} />
  </SubRouter>
))
